import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function createETLSequence(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/admin/processes/sequences/`,
    data,
    oauthTokenHeader
  );
}
function getETLSequences(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/admin/processes/sequences/`,
    oauthTokenHeader
  );
}

function getProcessList(oauthTokenHeader: string) {
    return fetchWrapper.get(`${apiUrl}/admin/processes/`, oauthTokenHeader);
  }
  function updateETLSequence(
    sequence_id: any,
    oauthTokenHeader: string,
    data: any
  ) {
    return fetchWrapper.put(
      `${apiUrl}/admin/processes/sequences/${sequence_id}/`,
      data,
      oauthTokenHeader
    );
  }
  function etlSequenceToggle(sequence_id: any, data: any, oauthTokenHeader: any) {
    return fetchWrapper.put(
      `${apiUrl}/admin/processes/sequences/toggle/${sequence_id}/`,
      data,
      oauthTokenHeader
    );
  }
  function deployETLSequence(data: any, oauthTokenHeader: string) {
    return fetchWrapper.post(
      `${apiUrl}/admin/processes/deploy/`,
      data,
      oauthTokenHeader
    );
  }

export const etlSequenceService = {
    createETLSequence,
    getETLSequences,
    getProcessList,
    updateETLSequence,
    etlSequenceToggle,
    deployETLSequence
}